module.exports = "<symbol id=\"tt-icon-star--half\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M12 2.09L9.09 9l-7.42.62 5.66 4.93-1.72 7.32 1.07-.65L12 17.97V2.09z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M12 2.09L14.91 9l7.42.62-5.66 4.93 1.72 7.32-1.07-.65L12 17.97V2.09z\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/Rdhcya1h7lLN3rcsite/assets/svg/pdp-page/star--half.svg
// module id = 283
// module chunks = 10